import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    socket: {
      isConnected: false,
      reconnectError: false,
    },
    jackpots: [],
    updated: null,
  },
  getters: {
    jackpotsReversed(state) {
      return [...state.jackpots]
        .sort((jp1, jp2) => (parseInt(jp2.price, 10) - parseInt(jp1.price, 10)));
    },
  },
  mutations: {
    SOCKET_ONOPEN(state) {
      state.socket.isConnected = true;
    },
    SOCKET_ONCLOSE(state, { code }) {
      if (code === 4403) {
        throw new Error('WebSocket closed by server');
      }

      state.socket.isConnected = false;
    },
    SOCKET_ONERROR(state, event) {
      console.error(state, event);
    },
    // default handler called for all methods
    SOCKET_ONMESSAGE(state, jackpots) {
      // remove jackpots with sum === 0
      state.jackpots = jackpots.filter(({ fg_sum: sum }) => (parseInt(sum, 10) > 0));
      state.updated = new Date();
    },
    // mutations for reconnect methods
    SOCKET_RECONNECT(state, count) {
      console.info(state, count);
    },
    SOCKET_RECONNECT_ERROR(state) {
      state.socket.reconnectError = true;
    },
  },
  actions: {
  },
  modules: {
  },
});
